import {
    Component,
    ContentChildren,
    QueryList,
    Input,
    AfterContentInit
} from '@angular/core';
import { OkExpansionPanelComponent } from './OkExpansionPanel.component';

export enum ExpansionStyle {
    OpenOnlyOneLevel = 1,
    OpenNextLevelOnClose,
    AllExpanded,
    AllClosed
}

@Component({
    selector: 'ok-multilevel-expansion-panel',
    template: ` <ng-content></ng-content> `,
    standalone: false
})
export class OkMultiLevelExpansionPanelComponent implements AfterContentInit {
    @Input()
    expansionStyle: ExpansionStyle;

    // Returns the specified elements or directives from the content DOM as QueryList
    @ContentChildren(OkExpansionPanelComponent)
    expansionPanels: QueryList<OkExpansionPanelComponent>;

    // The QueryList of the Content DOM elements is initialized only before
    // the ngAfterContentInit lifecycle hook, therefore, is available only from this point.
    ngAfterContentInit() {
        if (this.expansionStyle === ExpansionStyle.AllExpanded) {
            this.expansionPanels.forEach((panel) => (panel.isExpanded = true));
        } else if (this.expansionStyle === ExpansionStyle.AllClosed) {
            this.expansionPanels.forEach((panel) => (panel.isExpanded = false));
        }
        switch (this.expansionStyle) {
            case ExpansionStyle.OpenOnlyOneLevel:
                this.expansionPanels.forEach((expansionPanel) => {
                    expansionPanel.onExpand.subscribe(() => {
                        this.expansionPanels
                            .filter(
                                (selectedExpansionPanel) =>
                                    selectedExpansionPanel !== expansionPanel
                            )
                            .forEach((panel) => (panel.isExpanded = false));
                    });
                });
                break;

            case ExpansionStyle.OpenNextLevelOnClose:
                this.expansionPanels.forEach((expansionPanel, index) => {
                    expansionPanel.onClose.subscribe(() => {
                        const panel = this.expansionPanels.toArray()[++index];
                        if (panel) {
                            panel.isExpanded = true;
                        }
                    });
                });
                break;
            default:
        }
    }
}
